<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 800px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <p class='sub-title px-6 pb-6'>결제정보 자동 등록</p>
            <div class='scroll-area com-scroll-y px-6'>
              <div class="d-flex justify-content-end">
                <div class='com-searchbox'>
                  <button class='search-btn' type='button' @click='handleSearch'>
                    <span class='blind'>검색하기</span>
                  </button>
                  <input v-model='searchKeyword' placeholder="검색어를 입력해주세요" type='text'
                        @keyup.enter='handleSearch'>
                </div>
              </div>
              <div class='com-table-wrap mt-3'>
                <table class='com-table'>
                  <colgroup>
                      <col style='width:44px'>
                      <col style='width:120px'>
                      <col style='width:96px'>
                      <col>
                      <col style='width:104px'>
                      <col style='width:120px'>
                  </colgroup>
                  <thead>
                    <tr>
                      <th></th>
                      <th>결제일</th>
                      <th>승인번호</th>
                      <th>카드정보</th>
                      <th>할부</th>
                      <th>결제금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for='(p, index) in paymentInfoList' :key='index' class='pointer select-none'>
                      <td>
                        <div class="com-radio">
                          <input :id="`radio_${p.nt_id}`" name="select-payment-info" :value="p.nt_id" type="radio" @change="onSelectPaymentInfo"/>
                          <label :for="`radio_${p.nt_id}`"></label>
                        </div>
                      </td>
                      <td>{{formatDate(p.nt_app_dt)}}</td>
                      <td>{{p.nt_app_no}}</td>
                      <td>{{nicepayCards[p.nt_fn_cd] || ''}} {{ p.nt_payment_no | cardNumberFilter }}</td>
                      <td>
                        <span v-if="!!p.nt_install_mnt"  class="text-primary">
                          ({{ p.nt_install_mnt === '00' ? '일시불' : `${Number(p.nt_install_mnt)}개월` }})
                        </span>
                        <span v-else>---</span>
                      </td>
                      <td>{{p.nt_goods_amt | numberFormatFilter }}원</td>
                    </tr>
                    <tr v-if='paymentInfoList.length === 0'>
                        <td colspan='100'>
                          <loading-spinner v-if='loading' :height='120'></loading-spinner>
                          <span v-else>결제정보가 없습니다.</span>
                        </td>
                    </tr>
                  </tbody>
                </table>

                <b-pagination
                    v-model='pagingInfo.page'
                    :per-page='pagingInfo.limit'
                    :total-rows='pagingInfo.totalItems'
                    align='center'
                    aria-controls='my-table'
                    first-class='first'
                    last-class='last'
                    next-class='next'
                    prev-class='prev'
                    @change='handlerPagenation($event)'
                />
              </div>
              
              <div class='bottom-btn'>
                  <button class='com-btn' @click='onClosePop'>취소</button>
                  <button class='com-btn blue' :disabled="!selectedId" @click='handleSelect'>선택</button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import { NICEPAY_CARDS } from '@/assets/js/common';

export default {
  name: 'PaymentInfoDlg',
  components: { LoadingSpinner },
  props: {
    show: Boolean,
    close: Function,
    select: Function
  },
  computed: {
    centerId() {
      return this.$store.getters['auth/cId'];
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      loading: false,
      nicepayCards: { ...NICEPAY_CARDS },
      paymentInfoList: [],
      selectedId: null,
      searchKeyword: '',
      pagingInfo: {
        page: 1, // 페이지
        limit: 5, // 한 목록에 표출되는 건수
        totalItems: '', // 총 Item 수
        itemCount: '', // 현재 페이지 item 수
        totalPages: '', // 총 페이지 수
        route: '', // 링크 경로 생성시 프리픽스
      }
    };
  },
  methods: {
    async fetchPaymentInfoList(pageNum){
      if(this.isLoading) return

      this.isLoading = true;

      const res = await api.get(`/admin/api/center/fitpay/transactions/${this.centerId}`, {
          params: { 
              ...this.pagingInfo, 
              page: pageNum || this.pagingInfo.page,
              searchStr: this.searchKeyword || '',
            },
      });

      this.isLoading = false;
      if(res.data) {
        this.paymentInfoList = res.data.items || [];

          const metaData = res.data.meta;
          this.pagingInfo = {
              ...this.pagingInfo,
              page: metaData.currentPage,
              totalItems: metaData.totalItems, // 총 Item 수
              itemCount: metaData.itemCount, // 현재 페이지 item 수
              totalPages: metaData.totalPages, // 총 페이지 수
          }
      }
    },

    init(){
      this.searchKeyword = ''
      this.fetchPaymentInfoList(1)
    },

    onClosePop() {
      this.close();
    },

    handleSearch(){
      this.fetchPaymentInfoList();
    },

    handlerPagenation(num) {
      this.fetchPaymentInfoList(num);
    },

    onSelectPaymentInfo(e){
      this.selectedId = e.target.value || ''
    },

    handleSelect() {
      const selected = this.paymentInfoList.find((p) => p.nt_id === Number(this.selectedId))
      console.log('선택된 결제 정보')
      console.log(selected)
      this.select(selected)
    },

    formatDate(date) {
      if(!date) return '';
      return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`
    }
  },
};
</script>
<style scoped>

</style>
